import { render, staticRenderFns } from "./AppV2.vue?vue&type=template&id=2bcd55d4&lang=pug"
import script from "./AppV2.vue?vue&type=script&lang=js"
export * from "./AppV2.vue?vue&type=script&lang=js"
import style0 from "./AppV2.vue?vue&type=style&index=0&id=2bcd55d4&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bcd55d4')) {
      api.createRecord('2bcd55d4', component.options)
    } else {
      api.reload('2bcd55d4', component.options)
    }
    module.hot.accept("./AppV2.vue?vue&type=template&id=2bcd55d4&lang=pug", function () {
      api.rerender('2bcd55d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/AppV2.vue"
export default component.exports